import cn from 'clsx';
import { ReactNode } from 'react';

import s from '@/components/survey/common/ui/styles/WithChevronList.module.scss';
import ListIcon from '@/public/images/survey/ic-listin-right.svg';

interface Props {
  children: ReactNode;
  onClick?: () => void;
  className?: HTMLDivElement['className'];
}

export const WithChevronList = ({ children, onClick, className }: Props) => {
  return (
    <div onClick={onClick} className={cn(s.list_wrap, className)}>
      <div className={s.list_left}>{children}</div>
      <span className={s.list_right}>
        <ListIcon width={18} height={24} />
      </span>
    </div>
  );
};
